export function moneyFormat(number){
    let formatedNumber
    formatedNumber = number.toPrecision(number.toString().split('.')[0].length+2)
    
    return formatedNumber
}